export default {
  progress: state => state.progress,
  preload: state => state.preload,
  running: state => state.running,
  paused: state => state.paused,
  playlist: state => state.playlist,
  playlistId: state => (state.playlist && state.playlist.id) || null,
  volume: state => state.volume,
  shuffle: state => state.shuffle,
  repeat: state => state.repeat
};
